import { Button, Empty, Form, message, Modal, Select } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { OptionProps } from 'antd/lib/select';
import gql from 'graphql-tag';
import React from 'react';
import { Mutation, Query } from 'react-apollo';

interface Props {
  courseId: number;
  lessonId: number;
  form: any;
}

const formTailLayout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 12 },
};
const { Option } = Select;

export enum SpeechGroup {
  MARKETING, // 运营话术
  TEACHER_RATE, // 老师评语
}

export enum SpeechType {
  GOOD,
  BAD,
  GUIDE,
}

const ADD_SPEECH_MUTATION = gql`
  mutation createSpeech($type: Int!, $group: Int, $content: String, $sourceId: Int, $lessonId: ID) {
    createSpeech(type: $type, group: $group, content: $content, sourceId: $sourceId, lessonId: $lessonId) {
      id
    }
  }
`;

const TEACHING_POINTS_QUERY = gql`
  query teachingPoints($ids: [ID]) {
    courses(ids: $ids) {
      id
      teachingPoints {
        id
        name
      }
    }
  }
`;

interface State {
  type: number;
  id: number;
  group: number;
  teachingPointId: number;
  content: string;
  isShowSpeechModal: boolean;
}

export class SpeechAddition extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      type: 0,
      id: 0,
      group: 0,
      teachingPointId: 0,
      content: '',
      isShowSpeechModal: false,
    };
  }

  hideSpeechAdditionModal = () => {
    this.setState({ isShowSpeechModal: false });
  };

  getTeachingPoints(getFieldDecorator: any) {
    const { courseId } = this.props;
    return (
      <Query query={TEACHING_POINTS_QUERY} variables={{ ids: [courseId] }}>
        {({ loading, error, data }) => {
          if (error) return <div>{error.message}</div>;
          if (loading) return <div>loading...</div>;
          if (!data) {
            // @ts-ignore
            return <Empty />;
          }
          const courses = (data && data.courses) || [];
          const [course] = courses;
          const { teachingPoints } = course;
          return (
            <Form.Item label="核心知识点" {...formTailLayout}>
              {getFieldDecorator('teachingPointId', {
                rules: [
                  {
                    required: true,
                    message: '请选择teachingPoint',
                  },
                ],
              })(
                <Select
                  placeholder="请选择teachingPoint"
                  showSearch
                  onChange={(value: number) => {
                    this.setState({
                      teachingPointId: value,
                    });
                  }}
                  filterOption={(input: string, option: React.ReactElement<OptionProps>) => {
                    return String(option.props.children).indexOf(input) >= 0;
                  }}
                >
                  {teachingPoints.map((teachingPoint: { id: number; name: string }) => (
                    <Option value={teachingPoint.id} key={teachingPoint.id}>
                      {teachingPoint.name}
                    </Option>
                  ))}
                </Select>,
              )}
            </Form.Item>
          );
        }}
      </Query>
    );
  }

  onSpeechTypeChange = (value: number) => {
    this.setState({ type: value });
  };

  onSpeechGroupChange = (value: number) => {
    this.setState({ group: value });
  };

  onSpeechContentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({ content: e.target.value });
  };

  showSpeechAdditionModal = () => {
    this.setState({ isShowSpeechModal: true });
  };

  render() {
    const { type, content, teachingPointId, group } = this.state;
    const { getFieldDecorator } = this.props.form;
    const { lessonId } = this.props;
    return (
      <Mutation
        mutation={ADD_SPEECH_MUTATION}
        variables={{
          type,
          content,
          group,
          lessonId,
          sourceId: teachingPointId,
        }}
      >
        {createSpeech => {
          return (
            <>
              <Button type="primary" size="small" onClick={this.showSpeechAdditionModal}>
                添加话术
              </Button>
              <Modal
                title="添加话术"
                visible={this.state.isShowSpeechModal}
                onOk={async () => {
                  this.props.form.validateFields(
                    async (err: {
                      speechType: { message: string }[];
                      speechGroup: { message: string }[];
                      speechContent: { message: string }[];
                      teachingPointId: { message: string }[];
                    }) => {
                      if (err) {
                        message.error(err);
                        return;
                      }

                      try {
                        await createSpeech();
                        message.success('添加成功！');
                        this.setState({ isShowSpeechModal: false });
                      } catch (e) {
                        message.error('失败');
                      }
                    },
                  );
                }}
                onCancel={this.hideSpeechAdditionModal}
              >
                <Form className="login-form">
                  <Form.Item label="话术类型" {...formTailLayout}>
                    {getFieldDecorator('speechType', {
                      rules: [
                        {
                          required: true,
                          message: '请选择话术类型',
                        },
                      ],
                    })(
                      <Select placeholder="选择话术类型" onChange={this.onSpeechTypeChange}>
                        <Option value={SpeechType.BAD}>低话术</Option>
                        <Option value={SpeechType.GOOD}>高话术</Option>
                        <Option value={SpeechType.GUIDE}>引导话术</Option>
                      </Select>,
                    )}
                  </Form.Item>
                  <Form.Item label="话术分类" {...formTailLayout}>
                    {getFieldDecorator('speechGroup', {
                      rules: [
                        {
                          required: true,
                          message: '请选择话术分类',
                        },
                      ],
                    })(
                      <Select placeholder="选择话术分类" onChange={this.onSpeechGroupChange}>
                        <Option value={SpeechGroup.MARKETING}>运营话术</Option>
                        <Option value={SpeechGroup.TEACHER_RATE}>老师话术</Option>
                      </Select>,
                    )}
                  </Form.Item>
                  {this.getTeachingPoints(getFieldDecorator)}
                  <Form.Item label="话术内容" labelCol={{ span: 5 }} wrapperCol={{ span: 18 }}>
                    {getFieldDecorator('speechContent', {
                      rules: [
                        {
                          required: true,
                          message: '请添加话术内容',
                        },
                      ],
                    })(
                      <TextArea
                        placeholder="请输入话术内容"
                        rows={6}
                        autosize={false}
                        onChange={this.onSpeechContentChange}
                      />,
                    )}
                  </Form.Item>
                </Form>
              </Modal>
            </>
          );
        }}
      </Mutation>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/course/AddSpeech.tsx